import script from "./MapSectionBE.vue?vue&type=script&setup=true&lang=js"
export * from "./MapSectionBE.vue?vue&type=script&setup=true&lang=js"

import "./MapSectionBE.vue?vue&type=style&index=0&id=a5332926&lang=css"

const __exports__ = script;

export default __exports__